export function kebabToCamelCase(string: string) {
  return string.toLowerCase().replace(/_./g, x => x[1].toUpperCase())
}

export const errorPatterns = {
  UserAlreadyExistsException: /^User: `(.+)` already exists.$/,
  EmailAlreadyInUseException: /^Email is already in use$/,
  PasswordsDontMatchException: /^The provided passwords do not match.$/,
  DuplicatePasswordException: /^new password cannot be the same as current password$/,
  IncorrectPasswordException: /^Current password is wrong$/,
  UserNotFoundException: /^User not found!$/,
  InvalidOtpException: /^OTP is invalid$/
}

export function matchesPattern(errorMessage: string, pattern: keyof typeof errorPatterns) {
  return errorPatterns[pattern].test(errorMessage)
}

export function makeFirstCharLowerCase(str: string) {
  if (!str) return str
  return str.charAt(0).toLowerCase() + str.slice(1)
}
